<span class="grid-ui-last-update-info-icon" data-hook="last-update-info-icon-span">
  @if (!temporal) {
    <span
      placement="bottom"
      ngbTooltip="Indices marked with this icon are ATEMPORAL. Scores for this index are constant and do not change over time"
      class="last-update-info-container"
    >
      <grid-ui-icon class="last-update-info-icon" name="atemporal" data-hook="last-update-info-image"></grid-ui-icon>
    </span>
  }

  <span [class.pl-5]="temporal" [class.pl-3]="!temporal">
    {{ lastEdition }}
  </span>
</span>
